import ENVS from "@/app/api/config/env"

const { AUTH, API, AUTORIZACION, PAYWAY, FILE_MANAGER: FILE_MANAGER, MAILER } = ENVS

const isServer = typeof window === 'undefined';

export const getApiUrl = () => isServer ? API.PRIVATE_URL : API.PUBLIC_URL
export const getAuthUrl = () => isServer ? AUTH.PRIVATE_URL : AUTH.PUBLIC_URL
export const getAutorizacionUrl = () => isServer ? AUTORIZACION.PRIVATE_URL : AUTORIZACION.PUBLIC_URL
export const getPaywayUrl = () => isServer ? PAYWAY.PRIVATE_URL : PAYWAY.PUBLIC_URL
export const getFileManagerUrl = () => isServer ? FILE_MANAGER.PRIVATE_URL : FILE_MANAGER.PUBLIC_URL
export const getMailerUrl = () => isServer ? MAILER.PRIVATE_URL : MAILER.PUBLIC_URL

export const apiUrl = (endpoint: string) => getUrl(getApiUrl(), endpoint)
export const authUrl = (endpoint: string) => getUrl(getAuthUrl(), endpoint)
export const autorizacionUrl = (endpoint: string) => getUrl(getAutorizacionUrl(), endpoint)
export const paywayUrl = (endpoint: string) => getUrl(getPaywayUrl(), endpoint)
export const fileManagerUrl = (endpoint: string) => getUrl(getFileManagerUrl(), endpoint)
export const mailerUrl = (endpoint: string) => getUrl(getMailerUrl(), endpoint)

function getUrl(baseUrl: string, endpoint: string): string {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const url = `${baseUrl}${cleanEndpoint}`;

  return url;
}

export const config = {
  isServer,
  
  getApiUrl,
  getAuthUrl,
  getAutorizacionUrl,
  getPaywayUrl,
  getFileManagerUrl,
  getMailerUrl,

  apiUrl,
  authUrl,
  autorizacionUrl,
  paywayUrl,
  fileManagerUrl,
  mailerUrl,
};

